import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import moment from 'moment'
import 'moment/locale/es'
import 'moment/locale/de'
import 'moment/locale/pt'

import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { Languages } from './i18n.types'

const loadPath = () => '/locales/{{lng}}/{{ns}}.json'

const translateVersion = 'v2.407'

// Translations namespaces to be used by i18n
const nameSpaces = [
  'actions',
  'alerts',
  'analysis',
  'categoriesMenu',
  'columns',
  'common',
  'config',
  'configViews',
  'connect',
  'countries',
  'countriesAlph2',
  'datepicker',
  'dates',
  'emotionsWidget',
  'errors',
  'evolutionChart',
  'feeds',
  'fileInput',
  'fuzzySelect',
  'info',
  'learning',
  'locations',
  'locationsMetadata',
  'magicSearch',
  'mentions',
  'message',
  'modals',
  'navSidebar',
  'newProjectSetup',
  'openAi',
  'periodicReports',
  'profile',
  'projectNewListening',
  'public',
  'reports',
  'recovers',
  'sentiments',
  'summary',
  'socialLogin',
  'sources',
  'sourcesConfig',
  'toasts',
  'tooltips',
  'twitterConfig',
  'views',
  'viewsFilter',
]

// TODO: remove the myDetector language detector when we are ready to show translations in production
const myDetector = {
  name: 'MyDetector',
  lookup() {
    return Languages.spanish
  },
}

const languagedetector = new LanguageDetector(null, { autoDetect: true })
languagedetector.addDetector(myDetector)

// Update pt weekDays defaults: (1a,2a,3a,4a,5ta,Sa,Do)
moment.updateLocale('pt', {
  weekdaysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
  weekdays: [
    'domingo',
    'segunda-feira',
    'terça-feira',
    'quarta-feira',
    'quinta-feira',
    'sexta-feira',
    'sábado',
  ],
})

i18n.on('languageChanged', language => {
  moment.locale(language.toLocaleLowerCase().slice(0, 2))
})

i18n
  .use(HttpBackend)
  .use(languagedetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: ['querystring', 'localStorage'],
    },
    fallbackLng: Languages.spanish,
    debug: false,
    ns: nameSpaces,
    defaultNS: 'common',
    returnObjects: true,
    joinArrays: true,
    cleanCode: true,
    interpolation: {
      escapeValue: false,
      format(value, format) {
        if (value instanceof Date) return moment(value).format(format)
        return value
      },
    },
    backend: {
      loadPath,
      queryStringParams: { v: translateVersion },
    },
  })

export default i18n
